<nav
  class="navbar navbar-expand-lg navbar-light header-nav p-0 py-2"
  [ngClass]="{'custom-bg-black' : !check_home_page() }"
>
  <a
    class="navbar-brand text-center logo-hover ml-4 ml-rtl-0 mr-rtl-4"
    matRipple
  >
    <img src="./../../../../assets/images/logo.png" alt="logo" width="60px" />
  </a>

  <button
    class="bg-warning border-0 navbar-toggler shadow-none mr-4 mr-rtl-0 ml-rtl-4"
    type="button"
    data-toggle="collapse"
    data-target="#navbarTogglerDemo02"
    aria-controls="navbarTogglerDemo02"
    aria-expanded="false"
    aria-label="Toggle navigation"
    #mobile_nav_btn
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <div
    class="collapse navbar-collapse mr-0 mr-lg-4 mr-rtl-0 ml-rtl-0 ml-rtl-lg-4 nav-black-custom"
    id="navbarTogglerDemo02"
  >
    <ul
      class="w-100 navbar-nav mt-2 text-right align-items-lg-center ml-0 ml-lg-5 ml-rtl-0 ml-rtl-lg-5"
    >
      <li class="nav-item">
        <a
          (click)="toggle_mobile_nav(mobile_nav_btn)"
          class="nav-link d-flex px-2"
          href="#"
          matRipple
          routerLinkActive="active"
          routerLink=""
          [routerLinkActiveOptions]="{ exact: true }"
        >
            {{ "home" | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a
          (click)="toggle_mobile_nav(mobile_nav_btn)"
          class="nav-link d-flex px-2"
          href="#"
          matRipple
          routerLinkActive="active"
          routerLink="/ourPackages"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          {{ "Our Packages" | translate }}
        </a>
      </li>
      <!-- <li class="nav-item">
        <a
          (click)="toggle_mobile_nav(mobile_nav_btn)"
          class="nav-link d-flex px-2"
          href="#"
          matRipple
          routerLinkActive="active"
          routerLink="/دروس-تعليمية"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          {{ "tutorials" | translate }}
        </a>
      </li> -->
      <li class="nav-item">
        <a
          class="nav-link dropdown-toggle d-flex px-2 align-items-center gap-2 "
          href="#"
          id="ourServices"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          matRipple
        >
          {{ "Our Services" | translate }}
        </a>
        <div class="dropdown-menu" aria-labelledby="ourServices">
          <a
            (click)="toggle_mobile_nav(mobile_nav_btn)"
            class="dropdown-item text-start"
            matRipple
            routerLinkActive="active"
            routerLink="/تصميم-مواقع"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <img
              src="./../../../../assets/images/web-design.png"
              alt="web-design"
              class="icon"
            />
            {{ "web design" | translate }}
          </a>

          <a
            (click)="toggle_mobile_nav(mobile_nav_btn)"
            class="dropdown-item text-start"
            matRipple
            routerLinkActive="active"
            routerLink="/تصميم-برمجة--تطبيقات-الموبايل"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <img
              src="./../../../../assets/images/mobile.png"
              alt="mobile"
              class="icon"
            />
            {{ "mobile development" | translate }}
          </a>
        </div>
      </li>
      <li class="nav-item">
        <a
          class="nav-link dropdown-toggle d-flex px-2 align-items-center gap-2"
          href="#"
          id="ourOffers"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          matRipple
        >
          {{ "offers" | translate }}
        </a>

        <div class="dropdown-menu" aria-labelledby="ourOffers">
          <a
            (click)="toggle_mobile_nav(mobile_nav_btn)"
            class="dropdown-item text-start text-start"
            matRipple
            routerLinkActive="active"
            routerLink="/المتجر-الالكتروني-المتكامل"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <img
              src="./../../../../assets/images/shop.png"
              alt="car"
              class="icon"
            />
            {{ "full e-commerce" | translate }}
          </a>
          <a
            (click)="toggle_mobile_nav(mobile_nav_btn)"
            class="dropdown-item text-start"
            matRipple
            routerLinkActive="active"
            routerLink="/برنامج ادارة السيارات المؤجرة"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <img
              src="./../../../../assets/images/car.png"
              alt="car"
              class="icon"
            />
            {{ "cars program" | translate }}
          </a>
          <a
            (click)="toggle_mobile_nav(mobile_nav_btn)"
            class="dropdown-item text-start"
            matRipple
            routerLinkActive="active"
            routerLink="/imakeapps"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <img
              src="./../../../../assets/images/imakeapplogo.png"
              alt="car"
              class="icon"
            />
            {{ "restaurants system" | translate }}
          </a>
          <a
            (click)="toggle_mobile_nav(mobile_nav_btn)"
            class="dropdown-item text-start"
            matRipple
            routerLinkActive="active"
            routerLink="/نظام ادارة المدارس"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <img
              src="./../../../../assets/images/schools.png"
              alt="car"
              class="icon"
            />
            {{ "school managment system" | translate }}
          </a>
          <!-- <a
            (click)="toggle_mobile_nav(mobile_nav_btn)"
            class="dropdown-item text-start"
            matRipple
            routerLinkActive="active"
            routerLink="/imakeapps"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <img
              src="./../../../../assets/images/fruit-shop.png"
              alt="car"
              class="icon"
            />
            {{ "e-commerce platform" | translate }}
          </a> -->
        </div>
      </li>
      <li class="nav-item">
        <a
          (click)="toggle_mobile_nav(mobile_nav_btn)"
          class="nav-link  d-flex px-2"
          href="#"
          matRipple
          routerLinkActive="active"
          routerLink="/تواصل-معنا"
          [routerLinkActiveOptions]="{ exact: true }"
          [ngClass]="{ 'ms-lg-4': !is_signed_in() }"
        >
          {{ "call us" | translate }}
        </a>
      </li>

      
        <li class="nav-item">
            <a  (click)="toggle_mobile_nav(mobile_nav_btn);"
                class="nav-link"
                href="#"
                matRipple
                routerLinkActive="active"
                routerLink="/create-package"
                [routerLinkActiveOptions] = '{ exact: true }'
                *ngIf="is_signed_in();"
            >
                {{"create package" | translate}}
            </a>
        </li>

      <li class="nav-item">
            <a  (click)="toggle_mobile_nav(mobile_nav_btn);"
                class="nav-link"
                href="#"
                matRipple
                routerLinkActive="active"
                routerLink="/create-ticket"
                [routerLinkActiveOptions] = '{ exact: true }'
                *ngIf="is_signed_in();"
            >
                {{"create ticket" | translate}}
            </a>
        </li>


        <li class="nav-item">
            <a  (click)="toggle_mobile_nav(mobile_nav_btn);"
                class="nav-link ms-lg-4"
                href="#"
                matRipple
                routerLinkActive="active"
                routerLink="/auth/account/personal-info"
                [routerLinkActiveOptions] = '{ exact: true }'
                *ngIf="is_signed_in();"

            >
                {{"my account" | translate}}
            </a>
        </li>

      <li class="nav-item"></li>

      <!-- <li
        class="nav-item signing-btn ms-lg-3 overflow-hidden position-relative"
        style="width: 145px"
      ></li> -->
    </ul>
    <div
      class="d-flex gap-2 align-items-center justify-content-lg-start justify-content-center pb-3 pb-lg-0"
    >
      <div
        (click)="changeLanguage()"
        class="border border-2 border-light p-3 rounded-3 lang-rtl cursor-pointer d-flex gap-3 text-white"
        matRipple
      >
        <img [src]="'flag-url' | translate" alt="" width="30" />
        <p class="m-0">
          {{ "lang" | translate }}
        </p>
      </div>


      <!-- auth button -->
      <!-- <a
        (click)="toggle_mobile_nav(mobile_nav_btn)"
        matRipple
        class="btn bg-gold p-3 rounded-3 signing-btn text-nowrap cursor-pointer"
        routerLink="/auth/sign-in"
        (click)="btn_clicked()"
      >
        <p class="m-0 fw-bold">
          {{
            is_signed_in() ? ("log out" | translate) : ("log in" | translate)
          }}
        </p>
      </a> -->


    </div>
  </div>
</nav>
